export class DemographicModel{
patientcode = '';
menstrual ='';
yyy ='';
since = '2021-01-01';
contraception ='';
howlong =0;
howlongm =0;
marital ='';
nochildren ='';
ageoldest ='';
ageyoungest ='';
pregnancy ='';
pregnancydate = '2021-01-01';
pregnancyno ='';
pregnancyage =0;
smoker ='';
smokertype ='';
nopacks ='';
packsunit ='';
stype ='';
sdays =0 ;
ssince = '2021-01-01';
drinkingalcohol ='';
others ='';
mention ='';

compCode = '1';
userID = 'sa';
modifiedDate = '2021-01-01';
}
